// src/components/KPI.jsx
import React from "react";

export default function KPI({
  title,
  value,
  icon,
  dominant = false,
  percentage = null, // solo para salud
}) {
  // 🎨 Sistema de color por estado
  const pct = typeof percentage === "number" ? percentage : null;

  let accent = "from-blue-500 to-sky-400";
  let ring = "ring-blue-500/30";

  if (pct !== null) {
    if (pct < 75) {
      accent = "from-red-500 to-rose-400";
      ring = "ring-red-500/30";
    } else if (pct < 90) {
      accent = "from-amber-500 to-yellow-400";
      ring = "ring-amber-500/30";
    }
  }

  return (
    <div
      className={`
        relative overflow-hidden rounded-2xl
        bg-gradient-to-br from-slate-900 to-slate-950
        border border-slate-800
        shadow-xl transition-all
        ${dominant ? "p-8 scale-[1.04] ring-2 " + ring : "p-6"}
      `}
    >
      {/* Glow */}
      {dominant && (
        <div
          className={`absolute -top-12 -right-12 w-48 h-48 bg-gradient-to-br ${accent} opacity-25 blur-3xl`}
        />
      )}

      <div className="relative z-10 flex items-center gap-4">
        {icon && (
          <div className="w-12 h-12 rounded-xl bg-black/40 border border-slate-700 flex items-center justify-center text-xl">
            {icon}
          </div>
        )}

        <div className="flex-1">
          <p className="text-[11px] uppercase tracking-widest text-slate-400">
            {title}
          </p>

          <p className="mt-1 text-4xl font-extrabold text-blue-400">
            {value}
          </p>

          {/* Mini barra SOLO para dominante */}
          {dominant && pct !== null && (
            <div className="mt-3 h-2 w-full rounded-full bg-white/10 overflow-hidden">
              <div
                className={`h-full rounded-full bg-gradient-to-r ${accent} transition-all duration-700`}
                style={{ width: `${pct}%` }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
